// Simple i18n utility - no external dependencies, React 15 compatible
// Usage: import { t, setLang, getLang, onLangChange } from '../../i18n';

const en = {
    // Navigation
    'nav.dashboard': 'Dashboard',
    'nav.dashboard.stats': 'System Stats',
    'nav.dashboard.car': 'CAR',
    'nav.dashboard.creditRisk': 'Credit Risk',
    'nav.car': 'CAR',
    'nav.car.upload': 'Upload File',
    'nav.car.fileManagement': 'File Management',
    'nav.car.reports': 'Reports',
    'nav.capitalPlanning': 'Capital Planning',
    'nav.capitalPlanning.dashboard': 'Dashboard',
    'nav.capitalPlanning.report': 'Report',
    'nav.icaap': 'ICAAP',
    'nav.icaap.upload': 'Upload File',
    'nav.icaap.fileManagement': 'File Management',
    'nav.icaap.reports': 'Reports',
    'nav.masterTable': 'Master Table',
    'nav.masterTable.partyType': 'Party Type',
    'nav.masterTable.businessSector': 'Business Sector',
    'nav.raroc': 'RAROC',
    'nav.raroc.upload': 'Upload File',
    'nav.raroc.reports': 'Reports',
    'nav.raroc.fileManagement': 'File Management',
    'nav.pricing': 'Pricing',
    'nav.pricing.upload': 'Upload',
    'nav.pricing.fileManagement': 'File Management',
    'nav.pricing.processing': 'Processing',
    'nav.pricing.reports': 'Reports',
    'nav.configParameters': 'Config Parameters',
    'nav.configParameters.components': 'Components',
    'nav.configParameters.assetClass': 'Asset Class',
    'nav.configParameters.riskWeight': 'Risk Weight',
    'nav.user': 'User',
    'nav.role': 'Role',
    'nav.reportAccess': 'Report Access',
    'nav.activities': 'Activities',
    'nav.actionLog': 'Action Log',
    'nav.settings': 'Settings',
    // Common
    'common.search': 'Search',
    'common.filter': 'Filter',
    'common.clear': 'Clear',
    'common.upload': 'Upload',
    'common.download': 'Download',
    'common.delete': 'Delete',
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.confirm': 'Confirm',
    'common.close': 'Close',
    'common.loading': 'Loading...',
    'common.noData': 'No data available',
    'common.error': 'An error occurred',
    'common.success': 'Success',
    'common.status': 'Status',
    'common.action': 'Action',
    'common.date': 'Date',
    'common.name': 'File Name',
    'common.type': 'Type',
    'common.size': 'Size',
    // Dashboard
    'dashboard.title': 'System Dashboard',
    'dashboard.subtitle': 'Overview of all modules and system activity',
    'dashboard.users': 'System Users',
    'dashboard.carFiles': 'CAR Files',
    'dashboard.icaapFiles': 'ICAAP Files',
    'dashboard.rarocFiles': 'RAROC Files',
    'dashboard.pricingRecords': 'Pricing Records',
    'dashboard.totalFiles': 'Total Files',
    'dashboard.recentActivity': 'Recent Activity',
    'dashboard.filesByModule': 'File Count by Module',
    'dashboard.user': 'User',
    'dashboard.activityAction': 'Action',
    'dashboard.activityTime': 'Time',
    // Upload
    'upload.selectFile': 'Select File',
    'upload.dragDrop': 'Drag and drop your file here',
    'upload.fileType': 'Accepted file types: .xlsx, .xls',
    'upload.inProgress': 'Uploading...',
    'upload.complete': 'Upload Complete',
    'upload.failed': 'Upload Failed',
    // Reports
    'reports.title': 'Reports',
    'reports.noReports': 'No reports available',
    'reports.download': 'Download Report',
    'reports.view': 'View Report',
    // Login
    'login.username': 'Username',
    'login.password': 'Password',
    'login.submit': 'Login',
    'login.title': 'Sign In',
    // RAROC — STG_MR & COR CAP
    'rstg.upload.title': 'Upload — STG_MR & COR CAP',
    'rstg.upload.subtitle': 'Data for 3 sheets: IN_CAP_MR, IN_CAP_COR, IN_ICAAP_MR',
    'rstg.upload.cardTitle': 'Upload information',
    'rstg.mode.excel': 'Excel (1 file)',
    'rstg.mode.csv': 'CSV / TXT (3 files)',
    'rstg.field.reportDate': 'Report Date',
    'rstg.field.reportName': 'Report Name',
    'rstg.field.fileExcel': 'Data file (Excel)',
    'rstg.field.fileCsv': 'Data files (CSV / TXT — 3 sheets)',
    'rstg.drop.excelEmpty': 'Click to choose an Excel file',
    'rstg.drop.excelMeta': '.xlsx — one file with 3 sheets IN_CAP_MR / IN_CAP_COR / IN_ICAAP_MR',
    'rstg.drop.choose': 'Choose file',
    'rstg.drop.change': 'Change file',
    'rstg.drop.changeHint': 'click to change',
    'rstg.drop.csvMeta': '.csv / .txt',
    'rstg.btn.uploadCalc': 'Upload & Calculate',
    'rstg.btn.processing': 'Processing…',
    'rstg.upload.csvHint': 'Sheet names are normalized automatically on upload.',
    'rstg.dz.title': 'Drag & drop or click to select',
    'rstg.dz.hint': 'Accepts .xlsx, .csv or .txt — detected automatically.',
    'rstg.dz.excelReady': 'Excel file selected',
    'rstg.dz.sheetsReady': 'sheets ready',
    'rstg.excel.label': 'Excel file',
    'rstg.excel.meta': 'all sheets included',
    'rstg.csv.noFile': 'No file yet',
    'rstg.csv.choose': 'Select',
    'rstg.csv.removeFile': 'Remove file',
    'rstg.csv.unassignedTitle': 'Unrecognized files — assign manually',
    'rstg.csv.assignTo': 'Assign to…',
    'rstg.csv.discard': 'Discard file',
    'rstg.msg.excelOverride': 'Using the Excel file — dropped CSV/TXT files were ignored.',
    'rstg.err.badExt': 'Only .xlsx, .csv or .txt accepted; skipped',
    'rstg.err.badExtCsv': 'File must be .csv or .txt',
    'rstg.err.dupName': 'This Report Name already exists for the selected date. Please change the Report Name or Report Date, then upload again.',
    'rstg.msg.success': 'Calculation successful — result saved to History.',
    'rstg.err.noDate': 'Report Date is required.',
    'rstg.err.noName': 'Report Name is required.',
    'rstg.err.noExcel': 'Please choose an Excel file.',
    'rstg.err.missingFiles': 'Missing files for: ',
    'rstg.err.chunk': 'Chunk upload failed',
    'rstg.err.unknown': 'Unknown error',
    'rstg.err.prefix': 'Error',
    'rstg.result.title': 'STG_MR & COR CAP result',
    'rstg.fm.title': 'File Management',
    'rstg.fm.subtitle': 'STG_MR & COR CAP — manage uploaded batches',
    'rstg.fm.listTitle': 'List',
    'rstg.fm.empty': 'No batches yet',
    'rstg.fm.resultTitle': 'Result',
    'rstg.fm.confirmPre': 'Delete batch "',
    'rstg.fm.confirmPost': '"? File and history will be removed.',
    'rstg.rp.title': 'Reports',
    'rstg.rp.subtitle': 'STG_MR & COR CAP — calculated reports',
    'rstg.rp.listTitle': 'Reports list',
    'rstg.rp.empty': 'No reports yet',
    'rstg.common.refresh': 'Refresh',
    'rstg.btn.view': 'View',
    'rstg.btn.download': 'Download',
    'rstg.btn.delete': 'Delete',
    'rstg.btn.close': 'Close',
    'rstg.yes': 'Yes',
    'rstg.no': 'No',
    'rstg.col.reportName': 'Report Name',
    'rstg.col.reportDate': 'Report Date',
    'rstg.col.status': 'Status',
    'rstg.col.uploadedBy': 'Uploaded By',
    'rstg.col.uploadTime': 'Upload Time',
    'rstg.col.result': 'Result',
    'rstg.col.action': 'Action',
    'rstg.col.uploader': 'Uploader',
    'rstg.col.approver': 'Approver',
    'rstg.col.approvalTime': 'Approval Time',
    'rstg.field.dataFile': 'Data file',
    'rstg.btn.search': 'Search',
    'rstg.fm.uploadOnly': 'Upload only',
    'rstg.meta.snapshot': 'Snapshot date',
    'rstg.meta.cor': 'COR weight (max RW)',
    'rstg.meta.desks': 'Desks',
    'rstg.th.date': 'Date',
    'rstg.th.item': 'Item (Desk)',
    'rstg.th.mrBauWo': 'MR Cap. BAU (without DB)',
    'rstg.th.weight': 'Weight',
    'rstg.th.mrBauW': 'MR Cap. BAU (with DB)',
    'rstg.th.mrStressW': 'MR Cap. STRESS (with DB)',
    'rstg.th.corBau': 'COR Trading BAU (with DB)',
    'rstg.th.corStress': 'COR Trading STRESS (with DB)',
    // RAROC — process / stepper / upload flow
    'rstg.process.uploadFailed': 'Step 1/2 — Upload failed',
    'rstg.process.uploadFailedDesc': 'Upload interrupted. Please check your connection or input files and try again.',
    'rstg.process.validateFailed': 'Step 1/2 — Data validation failed',
    'rstg.process.validateSummary': 'Missing fields: {missing}, Wrong format: {wrong}{other}.',
    'rstg.process.validateOther': ', Other: {n}',
    'rstg.process.schemaInvalid': 'Schema/format validation failed.',
    'rstg.process.uploading': 'Step 1/2 — Uploading all files',
    'rstg.process.uploadingDesc': 'Uploading the complete dataset for all required sections.',
    'rstg.process.validating': 'Step 1/2 — Validating all sections',
    'rstg.process.validatingDesc': 'Checking schema and data types for each section.',
    'rstg.process.analyzing': 'Step 2/2 — Analyzing & generating outputs',
    'rstg.process.analyzingDesc': 'Generating output for all uploaded sections.',
    'rstg.process.done': 'Step 2/2 — Completed successfully',
    'rstg.process.doneDesc': 'Analysis and output generation for all sections complete.',
    'rstg.process.ready': 'Ready — Waiting for upload',
    'rstg.process.readyDesc': 'Upload all required files for every section, then click Upload once.',
    'rstg.step.prefix': 'Step',
    'rstg.step.upload': 'Upload Files',
    'rstg.step.check': 'Checking Data',
    'rstg.step.analyze': 'Analyzing',
    'rstg.step.output': 'Output Data',
    'rstg.files.title': 'Required input files',
    'rstg.files.sub': 'All RAROC data (STG_MR & COR CAP and RAROC CR) combined in one batch.',
    'rstg.files.excelPkg': 'Excel package',
    'rstg.files.remove': 'Remove file',
    'rstg.files.unassignedLabel': 'Unrecognized files — assign manually',
    'rstg.files.assignSheet': 'Assign to sheet…',
    'rstg.dz.dropAll': 'Drag & drop all RAROC data here',
    'rstg.dz.dropAllSub': 'One batch containing STG_MR & COR CAP and RAROC CR — the system auto-detects and assigns each file.',
    'rstg.dz.filesReady': 'files ready',
    'rstg.field.datasetName': 'Dataset Name',
    'rstg.upload.allReady': 'All {n} files ready. Ready to run the full pipeline.',
    'rstg.upload.stillMissing': '{n} more file(s) needed to start.',
    'rstg.btn.uploadAnalyze': 'Upload & Analyze',
    'rstg.btn.downloading': 'Downloading...',
    'rstg.btn.downloadSample': 'Download Sample',
    'rstg.btn.newDataset': 'Upload New Dataset',
    'rstg.err.noDataset': 'Please enter a Dataset Name.',
    'rstg.err.missingSection': 'Missing required files for: {title}. Please upload all data before running.',
    'rstg.msg.verifyDone': 'All section data verified. Starting combined analysis...',
    'rstg.msg.analyzing': 'Analyzing and building output for each section...',
    'rstg.msg.finishing': 'Finalizing results...',
    'rstg.msg.done': 'Done. Output generated for all sections.',
    'rstg.result.empty': 'No results yet. Upload all data and run again.',
    'rstg.meta.dataset': 'Dataset',
    'rstg.msg.excelPriority': 'Excel file prioritised for {title}.',
};

const vi = {
    // Navigation
    'nav.dashboard': 'Bảng Điều Khiển',
    'nav.dashboard.stats': 'Thống Kê Hệ Thống',
    'nav.dashboard.car': 'CAR',
    'nav.dashboard.creditRisk': 'Rủi Ro Tín Dụng',
    'nav.car': 'CAR',
    'nav.car.upload': 'Tải Lên Tệp',
    'nav.car.fileManagement': 'Quản Lý Tệp',
    'nav.car.reports': 'Báo Cáo',
    'nav.capitalPlanning': 'Kế Hoạch Vốn',
    'nav.capitalPlanning.dashboard': 'Bảng Điều Khiển',
    'nav.capitalPlanning.report': 'Báo Cáo',
    'nav.icaap': 'ICAAP',
    'nav.icaap.upload': 'Tải Lên Tệp',
    'nav.icaap.fileManagement': 'Quản Lý Tệp',
    'nav.icaap.reports': 'Báo Cáo',
    'nav.masterTable': 'Bảng Danh Mục',
    'nav.masterTable.partyType': 'Loại Đối Tượng',
    'nav.masterTable.businessSector': 'Ngành Kinh Doanh',
    'nav.raroc': 'RAROC',
    'nav.raroc.upload': 'Tải Lên Tệp',
    'nav.raroc.reports': 'Báo Cáo',
    'nav.raroc.fileManagement': 'Quản Lý Tệp',
    'nav.pricing': 'Định Giá',
    'nav.pricing.upload': 'Tải Lên',
    'nav.pricing.fileManagement': 'Quản Lý Tệp',
    'nav.pricing.processing': 'Xử Lý',
    'nav.pricing.reports': 'Báo Cáo',
    'nav.configParameters': 'Cấu Hình Tham Số',
    'nav.configParameters.components': 'Thành Phần',
    'nav.configParameters.assetClass': 'Nhóm Tài Sản',
    'nav.configParameters.riskWeight': 'Trọng Số Rủi Ro',
    'nav.user': 'Người Dùng',
    'nav.role': 'Vai Trò',
    'nav.reportAccess': 'Phân Quyền Báo Cáo',
    'nav.activities': 'Hoạt Động',
    'nav.actionLog': 'Nhật Ký Hoạt Động',
    'nav.settings': 'Cài Đặt',
    // Common
    'common.search': 'Tìm kiếm',
    'common.filter': 'Lọc',
    'common.clear': 'Xóa',
    'common.upload': 'Tải Lên',
    'common.download': 'Tải Xuống',
    'common.delete': 'Xóa',
    'common.save': 'Lưu',
    'common.cancel': 'Hủy',
    'common.confirm': 'Xác Nhận',
    'common.close': 'Đóng',
    'common.loading': 'Đang tải...',
    'common.noData': 'Không có dữ liệu',
    'common.error': 'Đã xảy ra lỗi',
    'common.success': 'Thành Công',
    'common.status': 'Trạng Thái',
    'common.action': 'Hành Động',
    'common.date': 'Ngày',
    'common.name': 'Tên Tệp',
    'common.type': 'Loại',
    'common.size': 'Kích Thước',
    // Dashboard
    'dashboard.title': 'Bảng Điều Khiển Hệ Thống',
    'dashboard.subtitle': 'Tổng quan tất cả các module và hoạt động hệ thống',
    'dashboard.users': 'Người Dùng Hệ Thống',
    'dashboard.carFiles': 'Tệp CAR',
    'dashboard.icaapFiles': 'Tệp ICAAP',
    'dashboard.rarocFiles': 'Tệp RAROC',
    'dashboard.pricingRecords': 'Bản Ghi Định Giá',
    'dashboard.totalFiles': 'Tổng Tệp',
    'dashboard.recentActivity': 'Hoạt Động Gần Đây',
    'dashboard.filesByModule': 'Số Tệp Theo Module',
    'dashboard.user': 'Người Dùng',
    'dashboard.activityAction': 'Hành Động',
    'dashboard.activityTime': 'Thời Gian',
    // Upload
    'upload.selectFile': 'Chọn Tệp',
    'upload.dragDrop': 'Kéo và thả tệp vào đây',
    'upload.fileType': 'Loại tệp chấp nhận: .xlsx, .xls',
    'upload.inProgress': 'Đang tải lên...',
    'upload.complete': 'Tải Lên Hoàn Tất',
    'upload.failed': 'Tải Lên Thất Bại',
    // Reports
    'reports.title': 'Báo Cáo',
    'reports.noReports': 'Không có báo cáo',
    'reports.download': 'Tải Báo Cáo',
    'reports.view': 'Xem Báo Cáo',
    // Login
    'login.username': 'Tên Đăng Nhập',
    'login.password': 'Mật Khẩu',
    'login.submit': 'Đăng Nhập',
    'login.title': 'Đăng Nhập',
    // RAROC — STG_MR & COR CAP
    'rstg.upload.title': 'Tải lên — STG_MR & COR CAP',
    'rstg.upload.subtitle': 'Dữ liệu 3 sheet: IN_CAP_MR, IN_CAP_COR, IN_ICAAP_MR',
    'rstg.upload.cardTitle': 'Thông tin tải lên',
    'rstg.mode.excel': 'Excel (1 tệp)',
    'rstg.mode.csv': 'CSV / TXT (3 tệp)',
    'rstg.field.reportDate': 'Ngày báo cáo',
    'rstg.field.reportName': 'Tên báo cáo',
    'rstg.field.fileExcel': 'Tệp dữ liệu (Excel)',
    'rstg.field.fileCsv': 'Tệp dữ liệu (CSV / TXT — 3 sheet)',
    'rstg.drop.excelEmpty': 'Bấm để chọn tệp Excel',
    'rstg.drop.excelMeta': 'Định dạng .xlsx — 1 tệp gồm 3 sheet IN_CAP_MR / IN_CAP_COR / IN_ICAAP_MR',
    'rstg.drop.choose': 'Chọn tệp',
    'rstg.drop.change': 'Đổi tệp',
    'rstg.drop.changeHint': 'bấm để đổi',
    'rstg.drop.csvMeta': '.csv / .txt',
    'rstg.btn.uploadCalc': 'Tải lên & Tính',
    'rstg.btn.processing': 'Đang xử lý…',
    'rstg.upload.csvHint': 'Tên sheet được chuẩn hoá tự động khi tải lên.',
    'rstg.dz.title': 'Kéo & thả hoặc bấm để chọn',
    'rstg.dz.hint': 'Nhận tệp .xlsx, .csv hoặc .txt — tự động nhận diện.',
    'rstg.dz.excelReady': 'Đã chọn tệp Excel',
    'rstg.dz.sheetsReady': 'sheet đã sẵn sàng',
    'rstg.excel.label': 'Tệp Excel',
    'rstg.excel.meta': 'gồm đủ các sheet',
    'rstg.csv.noFile': 'Chưa có tệp',
    'rstg.csv.choose': 'Chọn',
    'rstg.csv.removeFile': 'Xoá tệp',
    'rstg.csv.unassignedTitle': 'Tệp chưa nhận diện — gán thủ công',
    'rstg.csv.assignTo': 'Gán vào…',
    'rstg.csv.discard': 'Bỏ tệp',
    'rstg.msg.excelOverride': 'Đang dùng tệp Excel — đã bỏ qua các tệp CSV/TXT.',
    'rstg.err.badExt': 'Chỉ nhận .xlsx, .csv hoặc .txt; đã bỏ qua',
    'rstg.err.badExtCsv': 'Tệp phải là .csv hoặc .txt',
    'rstg.err.dupName': 'Report Name này đã tồn tại cho ngày đã chọn. Vui lòng đổi Report Name hoặc Report Date rồi tải lên lại.',
    'rstg.msg.success': 'Tính toán thành công — kết quả đã lưu vào Lịch sử.',
    'rstg.err.noDate': 'Chưa nhập Ngày báo cáo.',
    'rstg.err.noName': 'Chưa nhập Tên báo cáo.',
    'rstg.err.noExcel': 'Chưa chọn tệp Excel.',
    'rstg.err.missingFiles': 'Thiếu tệp cho: ',
    'rstg.err.chunk': 'Tải lên thất bại',
    'rstg.err.unknown': 'Lỗi không xác định',
    'rstg.err.prefix': 'Lỗi',
    'rstg.result.title': 'Kết quả STG_MR & COR CAP',
    'rstg.fm.title': 'Quản lý tệp',
    'rstg.fm.subtitle': 'STG_MR & COR CAP — quản lý các batch đã tải lên',
    'rstg.fm.listTitle': 'Danh sách',
    'rstg.fm.empty': 'Chưa có batch nào',
    'rstg.fm.resultTitle': 'Kết quả',
    'rstg.fm.confirmPre': 'Xoá batch "',
    'rstg.fm.confirmPost': '"? Tệp và lịch sử sẽ bị xoá.',
    'rstg.rp.title': 'Báo cáo',
    'rstg.rp.subtitle': 'STG_MR & COR CAP — báo cáo đã tính',
    'rstg.rp.listTitle': 'Danh sách báo cáo',
    'rstg.rp.empty': 'Chưa có báo cáo nào',
    'rstg.common.refresh': 'Làm mới',
    'rstg.btn.view': 'Xem',
    'rstg.btn.download': 'Tải báo cáo',
    'rstg.btn.delete': 'Xoá',
    'rstg.btn.close': 'Đóng',
    'rstg.yes': 'Có',
    'rstg.no': 'Không',
    'rstg.col.reportName': 'Tên báo cáo',
    'rstg.col.reportDate': 'Ngày báo cáo',
    'rstg.col.status': 'Trạng thái',
    'rstg.col.uploadedBy': 'Người tải',
    'rstg.col.uploadTime': 'Thời gian tải',
    'rstg.col.result': 'Kết quả',
    'rstg.col.action': 'Thao tác',
    'rstg.col.uploader': 'Người tải',
    'rstg.col.approver': 'Người duyệt',
    'rstg.col.approvalTime': 'Thời gian duyệt',
    'rstg.field.dataFile': 'File dữ liệu',
    'rstg.btn.search': 'Tìm kiếm',
    'rstg.fm.uploadOnly': 'Chỉ tải lên',
    'rstg.meta.snapshot': 'Ngày dữ liệu',
    'rstg.meta.cor': 'Hệ số COR (max RW)',
    'rstg.meta.desks': 'Số desk',
    'rstg.th.date': 'Ngày',
    'rstg.th.item': 'Hạng mục (Desk)',
    'rstg.th.mrBauWo': 'Vốn MR BAU (chưa DB)',
    'rstg.th.weight': 'Tỷ trọng',
    'rstg.th.mrBauW': 'Vốn MR BAU (có DB)',
    'rstg.th.mrStressW': 'Vốn MR STRESS (có DB)',
    'rstg.th.corBau': 'Vốn COR Trading BAU (có DB)',
    'rstg.th.corStress': 'Vốn COR Trading STRESS (có DB)',
    // RAROC — process / stepper / upload flow
    'rstg.process.uploadFailed': 'Bước 1/2 — Upload thất bại',
    'rstg.process.uploadFailedDesc': 'Upload gián đoạn. Vui lòng kiểm tra kết nối hoặc file đầu vào rồi thử lại.',
    'rstg.process.validateFailed': 'Bước 1/2 — Validate dữ liệu thất bại',
    'rstg.process.validateSummary': 'Thiếu trường: {missing}, Sai format: {wrong}{other}.',
    'rstg.process.validateOther': ', Khác: {n}',
    'rstg.process.schemaInvalid': 'Schema/format chưa đạt yêu cầu.',
    'rstg.process.uploading': 'Bước 1/2 — Đang upload tất cả file',
    'rstg.process.uploadingDesc': 'Đang upload bộ dữ liệu đầy đủ cho tất cả phần bắt buộc.',
    'rstg.process.validating': 'Bước 1/2 — Đang validate tất cả phần',
    'rstg.process.validatingDesc': 'Đang kiểm tra đầy đủ schema và kiểu dữ liệu cho từng phần.',
    'rstg.process.analyzing': 'Bước 2/2 — Đang phân tích & tạo output',
    'rstg.process.analyzingDesc': 'Đang tổng hợp output cho toàn bộ phần đã upload.',
    'rstg.process.done': 'Bước 2/2 — Hoàn tất thành công',
    'rstg.process.doneDesc': 'Phân tích và tạo result cho tất cả phần đã hoàn tất.',
    'rstg.process.ready': 'Sẵn sàng — Chờ upload',
    'rstg.process.readyDesc': 'Upload đủ file cho toàn bộ phần bắt buộc, sau đó bấm Upload một lần.',
    'rstg.step.prefix': 'Bước',
    'rstg.step.upload': 'Tải lên file',
    'rstg.step.check': 'Kiểm tra dữ liệu',
    'rstg.step.analyze': 'Phân tích',
    'rstg.step.output': 'Kết quả',
    'rstg.files.title': 'File đầu vào bắt buộc',
    'rstg.files.sub': 'Toàn bộ dữ liệu RAROC (STG_MR & COR CAP và RAROC CR) gộp chung một bộ.',
    'rstg.files.excelPkg': 'Gói Excel',
    'rstg.files.remove': 'Xoá file',
    'rstg.files.unassignedLabel': 'File chưa nhận diện — gán thủ công',
    'rstg.files.assignSheet': 'Gán vào sheet...',
    'rstg.dz.dropAll': 'Kéo & thả toàn bộ dữ liệu RAROC vào đây',
    'rstg.dz.dropAllSub': 'Một bộ duy nhất gồm STG_MR & COR CAP và RAROC CR — hệ thống tự nhận diện & sắp xếp từng file.',
    'rstg.dz.filesReady': 'file sẵn sàng',
    'rstg.field.datasetName': 'Tên bộ dữ liệu',
    'rstg.upload.allReady': 'Đã đủ {n} file. Sẵn sàng chạy toàn bộ luồng.',
    'rstg.upload.stillMissing': 'Còn thiếu {n} file để bắt đầu.',
    'rstg.btn.uploadAnalyze': 'Upload & Phân tích',
    'rstg.btn.downloading': 'Đang tải...',
    'rstg.btn.downloadSample': 'Tải file mẫu',
    'rstg.btn.newDataset': 'Upload bộ dữ liệu mới',
    'rstg.err.noDataset': 'Vui lòng nhập Tên bộ dữ liệu.',
    'rstg.err.missingSection': 'Thiếu file bắt buộc cho phần {title}. Vui lòng upload đủ dữ liệu trước khi chạy.',
    'rstg.msg.verifyDone': 'Đã verify đầy đủ dữ liệu cho tất cả phần. Bắt đầu phân tích tổng hợp...',
    'rstg.msg.analyzing': 'Đang phân tích và dựng output cho từng phần...',
    'rstg.msg.finishing': 'Đang hoàn tất kết quả...',
    'rstg.msg.done': 'Hoàn tất. Đã tạo output cho tất cả phần dữ liệu.',
    'rstg.result.empty': 'Chưa có kết quả. Hãy upload đủ dữ liệu và chạy lại.',
    'rstg.meta.dataset': 'Bộ dữ liệu',
    'rstg.msg.excelPriority': 'Đã ưu tiên file Excel cho {title}.',
};

const DICTIONARIES = { en, vi };
const STORAGE_KEY = 'ey_lang';
const LISTENERS = [];

let _currentLang = localStorage.getItem(STORAGE_KEY) || 'en';

export function getLang() {
    return _currentLang;
}

export function setLang(lang) {
    if (DICTIONARIES[lang]) {
        _currentLang = lang;
        localStorage.setItem(STORAGE_KEY, lang);
        LISTENERS.forEach((fn) => fn(lang));
    }
}

export function onLangChange(fn) {
    LISTENERS.push(fn);
    return () => {
        const idx = LISTENERS.indexOf(fn);
        if (idx !== -1) LISTENERS.splice(idx, 1);
    };
}

export function t(key, fallback) {
    const dict = DICTIONARIES[_currentLang] || DICTIONARIES['vi'];
    return dict[key] || fallback || key;
}

export default { t, setLang, getLang, onLangChange };



// WEBPACK FOOTER //
// src/i18n.js